import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";

import { DELETE_AMAZON_IDEA_TEMPLATE } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaTemplateCtx } from "../context";

export default function AmazonIdeaTemplateDelete({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaTemplateCtx();

    const [setDelay] = useTimeout();
    const [deleteAmazonIdeaTemplate, { loading }] = useMutation(
        DELETE_AMAZON_IDEA_TEMPLATE,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Delete amazon idea template successfully",
                    err: false,
                });
                onClose();
                onCompleted && onCompleted();

                setDelay(() => {
                    refetch && refetch();
                }, 1000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;
        setNotify && setNotify({ msg: null, err: false });
        toggleToast && toggleToast(true);

        deleteAmazonIdeaTemplate({
            variables: {
                ids,
            },
        });
    }, [ids, deleteAmazonIdeaTemplate, setNotify, toggleToast]);

    return (
        <Modal
            open={open}
            title="Delete Amazon Idea Template"
            onClose={onClose}
            sectioned
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Delete",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <p>Are you sure to delete this idea template?</p>
        </Modal>
    );
}
